import { searchParam, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { BomEditPage } from '@/areas/assemblies/BomItems/BomEditPage';
import { bomTabs } from '@/areas/assemblies/common/bomDetailsQueryParams';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/assemblies/$assemblyId/details')({
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: z.object({
        currentParentAssemblyId: z.string().optional(),
        designItemId: searchParam.list('optional'),
        filters: z.string().optional(),
        bomTab: searchParam.enum(bomTabs, 'optional'),
        dashboardFilters: z.string().optional(),
        search: z.string().optional(),
        onlyShowItemsWithManufacturingWarnings: searchParam.boolean('optional'),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const currentParentAssemblyId = Route.useSearch({ select: (search) => search.currentParentAssemblyId });
    const designItemId = Route.useSearch({ select: (search) => search.designItemId });
    const filters = Route.useSearch({ select: (search) => search.filters });
    const bomTab = Route.useSearch({ select: (search) => search.bomTab });
    const dashboardFilters = Route.useSearch({ select: (search) => search.dashboardFilters });
    const searchText = Route.useSearch({ select: (search) => search.search });
    const onlyShowItemsWithManufacturingWarnings = Route.useSearch({
        select: (search) => search.onlyShowItemsWithManufacturingWarnings,
    });
    const setSearch = useSetSearch();
    return (
        <BomEditPage
            {...pathParams}
            queryParams={{
                currentParentAssemblyId,
                designItemId,
                filters,
                bomTab,
                dashboardFilters,
                search: searchText,
                onlyShowItemsWithManufacturingWarnings,
            }}
            onSearchChange={setSearch}
        />
    );
}
